export const AdminStatusCssClasses = ["success", "info", ""];
export const AdminStatusTitles = ["active", "inactive"];
export const AdminConditionCssClasses = ["success", "danger", ""];
export const AdminConditionTitles = ["New", "Used"];
export const defaultSorted = [{ dataField: "userid", order: "asc" }];
export const sizePerPageList = [
  { text: "30", value: 30 },
  { text: "50", value: 50 },
  { text: "100", value: 100 }
];
export const initialFilter = {
  filter: {
    name: "",
    email: "",
    userid: "",
    current_userid:"",
  },
  sortOrder: "asc", // asc||desc
  sortField: "userid",
  pageNumber: 1,
  pageSize: 50
};